import {Injectable} from '@angular/core';
import {NEVER, Observable} from 'rxjs';
import * as APIM from '@common/utils/dist/models/api-messages.js';
import {
  WebsocketMessageProcessor,
  WSMessageProcessorInput,
  WSMessageProcessorOutput,
} from './websocket-message-processor';
import {ReceiveEventAcknowledgementAction} from '@actions/receive-event-acknowledgement.action';

@Injectable()
export class AcknowledgedMessageProcessor implements WebsocketMessageProcessor {
  constructor(
    private receiveEventAcknowledgementAction: ReceiveEventAcknowledgementAction,
  ) {}

  processMessage(
    params: WSMessageProcessorInput,
  ): Observable<WSMessageProcessorOutput> {
    const msg = params.msg;
    if (msg.int === APIM.EventIntent.AppAcknowledge) {
      params.wsAPI.acknowledge(msg.id);
      return this.receiveEventAcknowledgementAction.execute(msg.id);
    }
    return NEVER;
  }
}
